module.exports = __webpack_public_path__ + "gl.svg?59e1835690dfbbb0414e59a72686b054";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/gl.svg
// module id = 1122
// module chunks = 0